export const getAuthorizationHeaders = (sessionId) =>
  sessionId ? { Authorization: `Bearer ${sessionId}` } : {};

export const authenticatedFetch = (url, sessionId, options = {}) =>
  fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      ...getAuthorizationHeaders(sessionId),
    },
  });

export async function authenticatedJsonRequest(url, sessionId, options = {}) {
  const response = await authenticatedFetch(url, sessionId, {
    ...options,
    headers: {
      Accept: "application/json",
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...options.headers,
    },
  });

  if (!response.ok) {
    let message = `Request failed with status ${response.status}.`;
    try {
      const error = await response.json();
      message = error.message || error.error || message;
    } catch (error) {
      // Keep the status-based message when the server does not return JSON.
    }
    const requestError = new Error(message);
    requestError.status = response.status;
    throw requestError;
  }

  if (response.status === 204) return null;
  const text = await response.text();
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch (error) {
    return text;
  }
}
